/* eslint-disable @typescript-eslint/no-require-imports */
import CustomPlatform from "$src/core/utils/platform/platform";

import type { IconComponent } from "./types";

export default CustomPlatform.select<() => IconComponent>({
  web: () => require("./Icon.web").default,
  default: () => require("./Icon").default,
})();
